











































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rule from '@/domain/rule/entity/rule.entity';
import RuleService from '@/domain/rule/service/rule.service';
import Rules from '@/shared/rules/rules';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import RuleGroupItem from '@/domain/scripts/entity/rule-group-item.entity';
import RuleGroupItemParameter from '@/domain/scripts/entity/rule-group-item-parameter.entity';

@Component({
  components: {
    MainButton, LabelSlot,
  },
})
export default class ManagementEditionRules extends Vue {
  @Prop() rules!: Rule[];

  @Prop() isAdministrator!: boolean;

  @Prop() isEditMode!: boolean;

  @Prop() businessUnitId!: string;

  @Prop() previewModeValue!: boolean;

  @Prop() nameGroup!: string;

  @Prop() ruleGroup!: RuleGroup;

  internalNameGroup!: string;

  validationRules: Rules = new Rules();

  contentRules: Rule[] = [];

  contentRulesDB: Rule[] = [];

  get editColor(): string {
    return this.contentRules.length > 1
      ? 'red' : 'lightGray';
  }

  created() {
    this.getRules();
    this.internalNameGroup = this.nameGroup;
    this.prepareRules();
  }

  prepareRules() {
    if (!this.ruleGroup) {
      return
    }

    this.ruleGroup.rules.forEach((item: RuleGroupItem) => {
      const rule = new Rule({
        id: item.id,
        name: item.name,
        parameters: RuleGroupItemParameter.ofList(item.parameters),
      });
      this.contentRules.push(rule);
    });
  }

  getRules() {
    RuleService.getRules()
      .then((response: Rule[]) => this.contentRulesDB = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  updateRules(rule: Rule, index: number) {
    this.contentRules.splice(index, 1, rule);
    this.ruleGroup.rules.splice(index, 1, RuleGroupItem.of(rule));

    this.update();
  }

  clearRule(index: number) {
    this.contentRules.splice(index, 1, Rule.of({}));
    this.ruleGroup.rules.splice(index, 1, RuleGroupItem.of({}))
    this.update();
  }

  addNewRule() {
    this.contentRules.push(Rule.of({}));
    this.ruleGroup.rules.push(RuleGroupItem.of({}));
  }

  removeRule(index: number) {
    this.contentRules.splice(index, 1);
    this.ruleGroup.rules.splice(index, 1);
    this.update();
  }

  @Emit('updateRules')
  update() {
    this.ruleGroup.name = this.internalNameGroup;
    return { ruleGroup: this.ruleGroup, contentRules: this.contentRules };
  }
}
